import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-10 px-5 bg-petrol text-white text-center" data-id="element-45">
      <h2 className="text-xl font-heading font-bold text-gold mb-6" data-id="element-46">
        UN'ULTIMA OPPORTUNITÀ
      </h2>

      <div className="text-sm text-cream/90 space-y-3 mb-8" data-id="element-47">
        <p className="font-bold text-base text-white" data-id="element-48">
          I tuoi clienti meritano più di allenamenti improvvisati.
        </p>
        <p data-id="element-49">Smetti di passare ore a programmare.</p>
        <p data-id="element-50">Smetti di cercare esercizi ovunque.</p>
        <p data-id="element-51">Smetti di dubitare della struttura delle tue lezioni.</p>
        <p className="font-bold text-gold mt-4" data-id="element-52">
          Offri ai tuoi clienti un'esperienza professionale, organizzata e
          coinvolgente.
        </p>
      </div>

      <div className="bg-[#172D42] p-5 border border-gold/30 mb-6" data-id="element-53">
        <p className="text-sm font-bold text-white mb-2" data-id="element-54">
          FUNCTIONAL READY™ 6-in-1 Complete System + 5 Bonus Premium
        </p>
        <p className="text-sm line-through text-cream/50 mb-1" data-id="element-55">€97</p>
        <p className="text-3xl font-heading font-bold text-gold" data-id="element-56">
          Oggi Solo €24
        </p>
      </div>

      <a href="#pricing" className="block mb-6" data-id="element-57">
        <img src="https://cdn.magicpatterns.com/uploads/h9zfmASQDwvzTrNnkPRn2A/ChatGPT-Image-16-jun-2026_-21_22_56.webp" alt="FUNCTIONAL READY 6-in-1 Complete System" className="w-full max-w-[200px] mx-auto object-contain" loading="lazy" data-id="element-58" />
      </a>

      <div className="mb-6" data-id="element-59">
        <CTAButton data-id="element-60">🚀 SÌ, VOGLIO IL MIO FUNCTIONAL READY™</CTAButton>
      </div>

      <div className="flex flex-col gap-2 text-xs font-bold text-cream/80" data-id="element-61">
        <div data-id="element-62">⚡ Accesso Immediato — Consegna Digitale Istantanea</div>
        <div data-id="element-63">⭐ 4.9/5 — Recensioni Verificate</div>
        <div data-id="element-64">🛡️ Garanzia di 7 Giorni — Zero Rischi</div>
      </div>
    </section>;
}